var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-router-page"},[_c('CircularProgress',{staticClass:"c-router-progress",attrs:{"message":_vm.$t('message.redirecting')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }